<div class="table-skeleton__container">
  <table class="table-skeleton__table">
    <thead class="table-skeleton__header">
      <tr>
        <th *ngFor="let col of columns" [style.width]="col.width">
          <span
            class="table-skeleton__cell"
            [attr.aria-label]="col.label"
          ></span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of skeletonRows">
        <td *ngFor="let col of columns" [style.width]="col.width">
          <span class="table-skeleton__cell"></span>
        </td>
      </tr>
    </tbody>
  </table>
</div>
